import React, { useEffect, useState, useRef } from "react";
import "../../styles/CoughTestModal.css";
import RecordRTC from "recordrtc";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { addDiseaseData } from "../../Redux_Services/slices/diseaseSlice";
import mic from "../../assets/icons/mic.png";
import coughbg from "../../assets/icons/cough.png";
import { useNavigate } from "react-router-dom";
import CrossIcon from "../../assets/icons/cross.svg";
import { translations } from "../../translation/translate";

// const symptoms = [
//   { id: 1, symptomName: "cough_at_night", value: "0", symp: "Cough at night" },
//   { id: 2, symptomName: "sputum", value: "0", symp: "Sputum" },
//   { id: 3, symptomName: "wheezing", value: "0", symp: "Wheezing" },
//   { id: 4, symptomName: "frequent_cough", value: "0", symp: "Frequent Cough" },
//   { id: 5, symptomName: "pain_in_chest", value: "0", symp: "Pain in chest" },
//   {
//     id: 6,
//     symptomName: "shortness_of_breath",
//     value: "0",
//     symp: "Shortness of breath",
//   },
//   { id: 7, symptomName: "fatigue", value: "0", symp: "Fatigue" },
//   {
//     id: 8,
//     symptomName: "sweat_heavy_at_night",
//     value: "0",
//     symp: "Sweat heavy at night",
//   },
//   {
//     id: 9,
//     symptomName: "loss_of_appetite",
//     value: "0",
//     symp: "Loss of appetite",
//   },
//   { id: 10, symptomName: "weight_loss", value: "0", symp: "Weight loss" },
//   {
//     id: 11,
//     symptomName: "cough_with_sputum_and_blood",
//     value: "0",
//     symp: "Cough with sputum and blood",
//   },
//   {
//     id: 12,
//     symptomName: "evening_rise_in_temperature",
//     value: "0",
//     symp: "Evening rise in temperature",
//   },
//   {
//     id: 13,
//     symptomName: "known_person_having_active_tb",
//     value: "0",
//     symp: "Known person having active TB",
//   },
//   {
//     id: 14,
//     symptomName: "active_tb_in_the_past",
//     value: "0",
//     symp: "Active TB in the past",
//   },
//   {
//     id: 15,
//     symptomName: "family_history_of_asthma",
//     value: "0",
//     symp: "Family history of asthma",
//   },
//   {
//     id: 16,
//     symptomName: "active_asthma_in_the_past",
//     value: "0",
//     symp: "Active asthma in the past",
//   },
//   { id: 17, symptomName: "smoking", value: "0", symp: "Smoking" },
//   {
//     id: 18,
//     symptomName: "exposure_to_any_kind_of_smoke",
//     value: "0",
//     symp: "Exposure to any kind of smoke",
//   },
//   { id: 19, symptomName: "temperature_F", value: "0", symp: "Temperature (F)" },
//   { id: 20, symptomName: "pulse_rate", value: "0", symp: "Pulse rate" },
//   {
//     id: 21,
//     symptomName: "respiratory_rate",
//     value: "0",
//     symp: "Respiratory rate",
//   },
//   {
//     id: 22,
//     symptomName: "oxygen_saturation",
//     value: "0",
//     symp: "Oxygen saturation",
//   },
//   { id: 23, symptomName: "blood_pressure", value: "0", symp: "Blood pressure" },
//   {
//     id: 24,
//     symptomName: "frequent_cough_duration",
//     value: "0",
//     symp: "Frequent cough duration",
//   },
// ];

const CoughTestModal = ({ isOpen, onClose, title ,onValidated }) => {
    const langData = useSelector((state) => state.langSlice.langData);
    // console.log("langData: ",langData);
    const token = useSelector((state) => state.authSlice.user.token);
  
  const nav = useNavigate();
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15);
  const [sympData, setSympData] = useState([]);
  const [audioURL, setAudioURL] = useState("");
  const [audioFile, setAudioFile] = useState();
  const [coughValidationMessage, setCoughValidationMessage] = useState(null);
  const [proceed, setProceed] = useState(false);
  const [isCoughVerified, setIsCoughVerified] = useState(false);
  const [verifyResponse, setVerifyResponse] = useState(null);
  const [, setError] = useState(null);
  const recorderRef = useRef(null); // for recording cough
  const streamRef = useRef(null);
  const timerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const dispatch = useDispatch();

  const symptoms = [
    { id: 1, symptomName: "cough_at_night", value: "0", symp: translations[langData].coughAtNight },
    { id: 2, symptomName: "sputum", value: "0", symp: translations[langData].sputum },
    { id: 3, symptomName: "wheezing", value: "0", symp: translations[langData].wheezing },
    { id: 4, symptomName: "frequent_cough", value: "0", symp: translations[langData].frequentCough },
    { id: 5, symptomName: "pain_in_chest", value: "0", symp: translations[langData].painInChest },
    { id: 6, symptomName: "shortness_of_breath", value: "0", symp: translations[langData].shortnessOfBreath },
    { id: 7, symptomName: "fatigue", value: "0", symp: translations[langData].fatigue },
    { id: 8, symptomName: "sweat_heavy_at_night", value: "0", symp: translations[langData].sweatHeavyAtNight },
    { id: 9, symptomName: "loss_of_appetite", value: "0", symp: translations[langData].lossOfAppetite },
    { id: 10, symptomName: "weight_loss", value: "0", symp: translations[langData].weightLoss },
    { id: 11, symptomName: "cough_with_sputum_and_blood", value: "0", symp: translations[langData].coughWithSputumAndBlood },
    { id: 12, symptomName: "evening_rise_in_temperature", value: "0", symp: translations[langData].eveningRiseInTemperature },
    { id: 13, symptomName: "known_person_having_active_tb", value: "0", symp: translations[langData].knownPersonHavingActiveTb },
    { id: 14, symptomName: "active_tb_in_the_past", value: "0", symp: translations[langData].activeTbInThePast },
    { id: 15, symptomName: "family_history_of_asthma", value: "0", symp: translations[langData].familyHistoryOfAsthma },
    { id: 16, symptomName: "active_asthma_in_the_past", value: "0", symp: translations[langData].activeAsthmaInThePast },
    { id: 17, symptomName: "smoking", value: "0", symp: translations[langData].smoking },
    { id: 18, symptomName: "exposure_to_any_kind_of_smoke", value: "0", symp: translations[langData].exposureToAnyKindOfSmoke },
    { id: 19, symptomName: "temperature_F", value: "0", symp: translations[langData].temperatureF },
    { id: 20, symptomName: "pulse_rate", value: "0", symp: translations[langData].pulseRate },
    { id: 21, symptomName: "respiratory_rate", value: "0", symp: translations[langData].respiratoryRate },
    { id: 22, symptomName: "oxygen_saturation", value: "0", symp: translations[langData].oxygenSaturation },
    { id: 23, symptomName: "blood_pressure", value: "0", symp: translations[langData].bloodPressure },
    { id: 24, symptomName: "frequent_cough_duration", value: "0", symp: translations[langData].frequentCoughDuration },
  ];

  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const startTimer = () => {
    clearTimer();
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearTimer();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (isRecording && timeLeft === 0) {
      stopRecording();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, isRecording]);

  useEffect(() => () => clearTimer(), []);

  const stopMediaStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
  };

  // Function to start recording
  const startRecording = async () => {
    try {
      // document.querySelector('.')
      // Request microphone access
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      // Use RecordRTC's StereoAudioRecorder for recording in WAV format
      const options = {
        type: "audio",
        mimeType: "audio/wav",
        sampleRate: 44100, // Set the sample rate to 44100 Hz
        recorderType: RecordRTC.StereoAudioRecorder,
      };
      const recorder = new RecordRTC(stream, options);
      recorderRef.current = recorder;

      recorder.startRecording(); // Start recording
      setIsRecording(true);
      setIsPaused(false);
      setTimeLeft(15);
      startTimer();
      // console.log("Recording started.");
    } catch (error) {
      console.error("Error accessing microphone:", error);
      alert("Microphone access is required to record audio.");
    }
  };

  // Function to stop recording
  const stopRecording = () => {
    if (recorderRef.current) {
      clearTimer();
      setIsPaused(false);
      setIsRecording(false);
      recorderRef.current.stopRecording(() => {
        const blob = recorderRef.current.getBlob();
        if (blob) {
          processRecording(blob); // Process the recorded audio blob
          setAudioFile(blob);
        }
        recorderRef.current = null;
        stopMediaStream();
        // console.log(blob);
      });
      // console.log("Recording stopped.");
    }
  };

  const pauseRecording = () => {
    if (recorderRef.current && isRecording && !isPaused) {
      recorderRef.current.pauseRecording();
      setIsPaused(true);
      clearTimer();
    }
  };

  const resumeRecording = () => {
    if (recorderRef.current && isRecording && isPaused) {
      recorderRef.current.resumeRecording();
      setIsPaused(false);
      startTimer();
    }
  };

  // Function to process the recorded audio blob
  const processRecording = (blob) => {
    // Send the recorded audio to the verifycough API
    verifyCoughSample(blob);

    // Create a URL to play back the audio
    const audioUrl = URL.createObjectURL(blob);
    setAudioURL(audioUrl);
  };

  // Function to verify cough sample by sending it to the API
  const verifyCoughSample = async (blob) => {
    try {
      document.querySelector(".record-sec").style.padding = "20px 20px";
      setVerifyLoading(true);

      const formData = new FormData();
      formData.append("coughsoundfile", blob, "audio.wav");

      const apiResponse = await axios.post(
        "https://swaasa.sandbox.swaasa.ai/api/verifycough",
        formData,
        {
          headers: {
            Accept: "application/json",
            accessToken:
              "eyJhbGciOiJIUzUxMiIsImlhdCI6MTcyMTcxODU2OSwiZXhwIjoxOTgwOTE4NTY5fQ.eyJ1c2VySWQiOm51bGwsImxvZ2luSWQiOiJkaXNlYXNlX3ByZWRAc3dhYXNhLmFpIiwiclR5cGUiOiJhZG1pbiIsInBsYW4iOiJ2aXRhbHMscGx1cyx0Yixjb3BkLGFzdGhtYSxzcGlyb21ldHJ5IiwiYWNjZXNzVG9rZW4iOm51bGwsInVzZXJEZXRhaWxzIjpudWxsLCJwYXJlbnRJZCI6bnVsbCwiY29uZmlndXJhdGlvbiI6e319.w8l-tbdal_61Omqw6qB5lE6lsNqr-SN3HKcHsdf-xbiF61PXiWO71MzwX411gBAFk6QhWbg3BH9Mco57jyb07A",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const payload = apiResponse?.data || {};
      setVerifyResponse(payload);

      const apiStatus = payload?.status;
      const apiData = payload?.data || {};
      const isValid = apiStatus === "SUCCESS" && !!apiData?.isValidCough;

      if (isValid) {
        setIsCoughVerified(true);
        setCoughValidationMessage(
          "Cough sample verified successfully. Please choose the symptoms."
        );
        setProceed(true); // Auto-expand symptom section after successful verification
        if (typeof onValidated === "function") {
          onValidated({ status: "Valid", keepOpen: true });
        }
      } else {
        const invalidMessage =
          apiData?.message || payload?.message || "Cough is not valid.";
        setIsCoughVerified(false);
        setCoughValidationMessage(invalidMessage);
        setProceed(false);
        if (typeof onValidated === "function") {
          onValidated({ status: "Invalid", keepOpen: true });
        }
        alert(invalidMessage);
      }
    } catch (error) {
      console.error("Error verifying cough:", error);
      setIsCoughVerified(false);
      setCoughValidationMessage("Error verifying the cough sample.");
      setError(error);
      if (typeof onValidated === "function") {
        onValidated({ status: "Error", keepOpen: true });
      }
    } finally {
      setVerifyLoading(false);
    }
  };


  const sendDiseaseLikelyRequest = async () => {
    setLoading(true);
    const selectedSymp = symptoms.reduce((acc, { symptomName, value }) => {
      acc[symptomName] = value;
      return acc;
    }, {});
    const formData = new FormData();
    formData.append("coughsoundfile", audioFile, "audio.wav"); // 'audioFile' should be a File or Blob
    formData.append("symptoms", JSON.stringify(selectedSymp));
    const assessmentId = verifyResponse?.data?.assessmentId;
    if (!assessmentId) {
      alert("Please verify the cough sample before submitting.");
      setLoading(false);
      return;
    }

    formData.append("assessmentId", assessmentId);
    formData.append("gender", "1");
    formData.append("age", "23");
    try {
      const diseaseLikelyResponse = await axios.post(
        "https://swaasa.sandbox.swaasa.ai/api/diseaselikely",
        formData,
        {
          headers: {
            Accept: "application/json",
            accessToken:
              "eyJhbGciOiJIUzUxMiIsImlhdCI6MTcyMTcxODU2OSwiZXhwIjoxOTgwOTE4NTY5fQ.eyJ1c2VySWQiOm51bGwsImxvZ2luSWQiOiJkaXNlYXNlX3ByZWRAc3dhYXNhLmFpIiwiclR5cGUiOiJhZG1pbiIsInBsYW4iOiJ2aXRhbHMscGx1cyx0Yixjb3BkLGFzdGhtYSxzcGlyb21ldHJ5IiwiYWNjZXNzVG9rZW4iOm51bGwsInVzZXJEZXRhaWxzIjpudWxsLCJwYXJlbnRJZCI6bnVsbCwiY29uZmlndXJhdGlvbiI6e319.w8l-tbdal_61Omqw6qB5lE6lsNqr-SN3HKcHsdf-xbiF61PXiWO71MzwX411gBAFk6QhWbg3BH9Mco57jyb07A", // Replace with your actual access token
            Authorization:
              `Bearer ${token}`, // Replace with your actual JWT token
          },
          // withCredentials: true, // Ensure credentials are included in the request
        }
      );
      const diseasePayload = diseaseLikelyResponse.data;
      diseasePayload.symptoms = selectedSymp;
      dispatch(addDiseaseData(diseasePayload));
      // console.log(diseasePayload);
      nav("/testparameter");
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
      alert("Recording is not appropriate! Please record again");
      resetRecordingState();
    } finally {
      setLoading(false);
    }
  };

  // Function to reset the recording state
  const resetRecordingState = () => {
    document.querySelector(".record-sec").style.padding = "80px 20px";
    clearTimer();
    stopMediaStream();
    setIsRecording(false);
    setIsPaused(false);
    setTimeLeft(15);
    setProceed(false);
    setAudioURL("");
    setCoughValidationMessage(null);
    setIsCoughVerified(false);
    setAudioFile(null);
    setVerifyLoading(false);
    if (recorderRef.current) {
      recorderRef.current = null;
    }
    symptoms.forEach((item) => {
      item.value = "0";
    });
    setSympData([]);
    setVerifyResponse(null);
    if (typeof onValidated === "function") {
      onValidated({ status: "", keepOpen: true });
    }
  };

  // Function for styling and creating selected symptoms object for /diseaseLikely endpoint
  const selectSymp = (id, symp) => {
    document.getElementById(`${id}`).classList.toggle("list-content-selected");
    if (sympData.length === 0) {
      setSympData([symp]);
      return;
    }
    setSympData((prev) => [...prev, symp]);
    const res = symptoms.find((item) => item.id === id);
    if (res.value === "0") {
      res.value = "1";
    } else {
      res.value = "0";
    }
  };

  // useEffect(() => {
  //   console.log(sympData);
  //   console.log(symptoms);
  // }, [selectSymp]);

  if (!isOpen) return null;

  return (
    <div className="testpage">
      <div className="testpage-modal">
        <div className="modal-cont">
          <div className="record-sec">
            <button
              onClick={() => {
                resetRecordingState();
                onClose();
                console.log("clicked");
              }}
              className="close-btn"
            >
              <img src={CrossIcon} alt="" />
            </button>
            <div className="record-head">
              <img src={mic} alt="microphone-icon" />
              <h2>{translations[langData].RecordYourAudio}</h2>
            </div>
            <div className="action-btns">
              {!isRecording && (
                <div className="btn" onClick={startRecording}>
                  {translations[langData].startRecording}
                </div>
              )}

              {isRecording && (
                <>
                  {!isPaused ? (
                    <div className="btn pause-btn" onClick={pauseRecording}>
                      {translations[langData].pauseRecording}
                    </div>
                  ) : (
                    <div className="btn resume-btn" onClick={resumeRecording}>
                      {translations[langData].resumeRecording}
                    </div>
                  )}
                  <div className="btn stop-btn" onClick={stopRecording}>
                    {translations[langData].stopRecording}
                  </div>
                </>
              )}
            </div>
            {isRecording && (
              <div className="recording-timer">
                {translations[langData].recordingTimeLeft}: 00:
                {String(timeLeft).padStart(2, "0")}
                {isPaused && (
                  <span className="recording-status">
                    {" "}
                    ({translations[langData].paused})
                  </span>
                )}
              </div>
            )}
            {audioURL && (
              <div style={{ marginTop: "15px" }}>
                <audio
                  controls
                  src={audioURL}
                  style={{ width: "50%", height: "40px", marginBottom: "10px" }}
                />
              </div>
            )}
            {coughValidationMessage && (
              <>
                <p className="cough-validation-message">{coughValidationMessage}</p>
                <div className="auth-true-action">
                  {isCoughVerified && !proceed && (
                    <div onClick={() => setProceed(true)} className="proceed-btn">
                      {translations[langData].proceed}
                    </div>
                  )}
                  <div onClick={resetRecordingState} className="reset-btn">
                    {translations[langData].Reset}
                  </div>
                </div>
              </>
            )}
            <div className="img-cough">
              <img className="cough-bg" src={coughbg} alt="" />
            </div>
          </div>
        </div>
        {proceed ? (
          <>
            <div className="symptoms-list">
              <h2 className="symp-heading">{translations[langData].SelectSymptoms}</h2>
              <ul>
                {symptoms.map((a) => (
                  <li
                    key={a.id}
                    onClick={() => selectSymp(a.id, a.symp)}
                    id={a.id}
                    className="list-content"
                  >
                    {a.symp}
                  </li>
                ))}
              </ul>
            </div>
            <div className="submissive-action-btn">
              <div
                onClick={sendDiseaseLikelyRequest}
                className="submissive-btn"
              >
                {translations[langData].submit}
              </div>
              <div onClick={resetRecordingState} className="submissive-btn">
                {translations[langData].Reset}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      {(verifyLoading || loading) && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="w-10 h-10 border-4 border-t-red-500 border-gray-300 rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
};

export default CoughTestModal;
